import { FILED_NOT_WATCH } from '../../../tokens/index'
import { provide, ref, shallowRef, nextTick } from 'vue'
import {
  getValueByPath,
  setValueByPath,
  setValueByPathToVue,
  clone,
  createID,
} from '../../../utils/index'

export function useTable() {
  const tableCompileData = ref({})
  const tableStaticData = shallowRef({})
  const tableMethods = {}

  const setInitTableCompileData = (items, data) => {
    const tableCompile = {}
    const tableStatic = {}
    for (const item of items) {
      if (
        item.componentCode === 'PgPageEditTable' ||
        item.component?.code === 'PgPageEditTable' ||
        item.componentCode === 'PgPageEditTableDrag' ||
        item.component?.code === 'PgPageEditTableDrag'
      ) {
        tableStatic[item.property] = getValueByPath(data, item.property)
        setValueByPath(data, item.property, undefined)
        tableCompile[item.property] = {
          selectionIds: [],
          getSelectionIds: () => tableCompile[item.property].selectionIds,
          dataIds: [],
          getDataIds: () => tableCompile[item.property].dataIds,
          parameters: null,
          getParameters: () => tableCompile[item.property].parameters,
        }
      }
    }
    tableStaticData.value = tableStatic
    tableCompileData.value = tableCompile
    return data
  }
  //加载表格数据
  const loadTable = (property, isRequest) => {
    if (property) {
      tableMethods[property].loadData?.(tableStaticData.value[property], isRequest)
    } else {
      nextTick(() => {
        const keys = Object.keys(tableMethods)
        for (const key of keys) {
          tableMethods[key].loadData?.(tableStaticData.value[key], isRequest)
        }
      })
    }
  }

  //添加表格数据 在PgEditTable组件中使用时不传data参数
  const addTableRows = ({ data, property, rows = [], aimRow, key = '_ID', unshift = false }) => {
    const targetData = data || tableStaticData.value
    if (!targetData[property]) {
      if (data) {
        setValueByPathToVue(targetData, property, [])
      } else {
        targetData[property] = []
      }
    }
    if (aimRow) {
      const aimIndex = targetData[property].findIndex(
        (im) => getValueByPath(im, key) === getValueByPath(aimRow, key)
      )
      targetData[property].splice(aimIndex + 1, 0, ...rows)
    } else {
      if (unshift) {
        targetData[property].unshift(...rows)
      } else {
        targetData[property].push(...rows)
      }
    }
    if (!data) loadTable(property)
  }
  //删除表格中数据 在PgEditTable组件中使用时不传data参数
  const removeTableRows = ({ data, property, ids = [], key = '_ID', checkedKey }) => {
    const targetData = data || tableStaticData.value
    targetData[property] = targetData[property].filter((im) =>
      !checkedKey ? !ids.includes(getValueByPath(im, key)) : !getValueByPath(im, checkedKey)
    )
    if (!data) loadTable(property)
  }
  //替换行 在PgEditTable组件中使用时不传data参数
  const replaceRows = ({ data, property, rows = [], aimRow, key = '_ID' }) => {
    const targetData = data || tableStaticData.value
    if (!aimRow) {
      targetData[property] = targetData[property].map((im) => {
        const newRow = rows.find((row) => getValueByPath(row, key) === getValueByPath(im, key))
        if (newRow) {
          return newRow
        } else {
          return im
        }
      })
    } else {
      const aimIndex = targetData[property].findIndex(
        (im) => getValueByPath(im, key) === getValueByPath(aimRow, key)
      )
      targetData[property].splice(
        aimIndex,
        1,
        ...rows.map((im) => {
          setValueByPath(im, key, null)
          return im
        })
      )
    }

    if (!data) loadTable(property)
  }
  //复制行 在PgEditTable组件中使用时不传data参数
  const copyRows = ({ data, property, row, key = '_ID' }) => {
    const targetData = data || tableStaticData.value
    const index = targetData[property].findIndex(
      (im) => getValueByPath(im, key) === getValueByPath(row, key)
    )
    const addIndex = index === -1 ? targetData[property].length : index + 1
    const addRow = clone(row)
    setValueByPath(addRow, key, createID())
    targetData[property].splice(addIndex, 0, addRow)
    if (!data) loadTable(property)
  }

  // 校验表格数据
  const fullValid = async (propertys = []) => {
    const keys = Object.keys(tableMethods)
    const tableErrorMap = []
    for (const key of keys) {
      if (propertys.includes(key)) {
        const errorMap = await tableMethods[key].fullValid()
        if (errorMap) tableErrorMap.push(...errorMap)
      }
    }
    return tableErrorMap.length > 0 ? tableErrorMap : undefined
  }
  provide(FILED_NOT_WATCH, {
    init: (property, val) => {
      if (!property) {
        console.error('请配置表格数据在表单中字段名')
      } else {
        tableMethods[property] = val
      }
    },
    setData: (property, data, key) => {
      tableStaticData.value[property] = data
      tableCompileData.value[property].dataIds = data?.map((im) => getValueByPath(im, key))
    },
    onSelections: (property, data, key) => {
      tableCompileData.value[property].selectionIds = data.map((im) => getValueByPath(im, key))
    },
    // 保存查询参数
    onSeachParameters: (property, data) => {
      tableCompileData.value[property].parameters = data
    },
    //加载表格数据
    loadTable: (property) => loadTable(property),
  })

  return {
    tableCompileData, // 表格数据的key数组和选中项key数组(默认_ID,支持在表格组件进行配置)
    tableStaticData, // 表格数据
    setInitTableCompileData, // 设置表格数据
    loadTable, // 渲染表格数据
    fullValid,
    addTableRows,
    removeTableRows,
    replaceRows,
    copyRows,
  }
}
